import './main-block.scss';
import imageBg from './bg_image.png';
export default function MainBlock() {

    return <div className="main-block">
        <div className="main-block__wrapper container">
            <div className="main-block__column">
                <h1 className="main-block__title title">Trade like an algorithm. <br/> <span>Fast. Accurate. Emotion free.</span>
                </h1>
                <p className="main-block__text">
                    Automation, real-time signals, and deep liquidity — all in one platform.
                </p>

                <a href={process.env.REACT_APP_LINK} className="main-block__button button">Open an Account</a>
            </div>

            <img src={imageBg} className="main-block__image" alt=""/>
        </div>



    </div>
}